import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styles from './DirectoryCategoryPage.css'; // We will use inline styles or a module if we convert it
import Header from './components/Header';
import Footer from './components/Footer';
import SearchFormComponent from '../Dashboards/SearchFormComponent';
import SocialProofEngine from '../../components/SocialProof/SocialProofEngine';
import FeaturedBusinessBanner from '../../components/FeaturedBusinessBanner/FeaturedBusinessBanner';


import './DirectoryCategoryPage.css'; // Import the CSS file

//import imageLand from '../../assets/images/imgConsultantsLand.jpg';

const DirectoryCategoryPage = () => {
  const { category } = useParams();
  const navigate = useNavigate();

  // Helper to format category name
const formatCategory = (slug) => {
  if (!slug) return '';

  return slug
    .replace(/-/g, ' ')              // replace hyphens with spaces
    .replace(/\b\w/g, char => char.toUpperCase()); // capitalise each word
};

  const categoryName = formatCategory(category);

  // Mock Data for Teaser Profiles
  const teaserProfiles = [
    { id: 1, name: 'John D.', rating: 5, initial: 'J' },
    { id: 2, name: 'Mike S.', rating: 4.8, initial: 'M' },
    { id: 3, name: 'Sarah L.', rating: 4.9, initial: 'S' },
    { id: 4, name: 'David B.', rating: 5, initial: 'D' },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [category]);

  const handleGetQuotes = () => {
      // Trigger job post flow or navigate to role selection
      navigate('/select-role');
  };

  return (
    <div className="directoryPage">
      <SocialProofEngine />
      <Header />
      
      <main>
        {/* Hero Section */}
        <section className="hero">
          <h1 className="heroTitle">Hire Top Rated {categoryName} Near You</h1>
          <p className="heroSubtitle">
            Connect with highly professional {categoryName} in seconds. 
            Enter your location to see who is available.
          </p>
          
          <div className="searchWrapper">
             {/* Pre-fill the search term with the category */}
            <SearchFormComponent key={category} initialSearchTerm={categoryName} showVoice={false} />
          </div>
        </section>


  


        {/* Teaser Profiles Section */}
        {/*}
        <section className="teaserSection">
          <div className="container">
            <h2 className="teaserTitle">Top Rated {categoryName} available now</h2>
            
            <div className="teaserGrid">
              {teaserProfiles.map((profile) => (
                <div key={profile.id} className="teaserCard">
                  <div className="avatar">{profile.initial}</div>
                  <h3 className="proName">{profile.name}</h3>
                  <div className="proRating">
                    {'★'.repeat(Math.floor(profile.rating))} 
                    ({profile.rating})
                  </div>
                  <button className="ctaButton" onClick={handleGetQuotes}>
                    Get Quotes
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section>

        */}

        {/* SEO Content Section */}
        <section className="seoSection">
          <div className="container seoContent">
            <h2>What does a {categoryName} do?</h2>
            <p>
              Professional {categoryName.toLowerCase()} play a crucial role in construction and renovation projects. 
              They are responsible for ensuring high-quality workmanship and adherence to safety standards. 
              Whether you are looking for residential or commercial services, hiring a verified {categoryName.toLowerCase()} 
              {' '} through Build Start ensures you get the best results for your project.
            </p>
            
            <h2>Average Prices for {categoryName}</h2>
            <p>
              The cost of hiring {categoryName.toLowerCase()} can vary depending on the scope of work, location, and experience level. 
              On average, you can expect competitive rates when comparing quotes from multiple professionals. 
              Post a job on Build Start to receive accurate quotes tailored to your specific needs.
            </p>

            <h2>Why hire through Build Start?</h2>
            <p>
              Build Start connects you with verified professionals who have been vetted for licenses and insurance. 
              Our platform makes it easy to compare profiles, read reviews, and hire the right person for the job 
              with confidence. Avoid the hassle of searching through endless directories and let the professionals come to you.
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default DirectoryCategoryPage;
